import { types } from "../actions";

export default (state = null, { type, payload }) => {
  switch (type) {
    case types.SET_OPPORTUNITY:
      return payload;
    case types.RESET:
      return null;
    default:
      return state;
  }
};
